import { error, money } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const DebitCardFundingOptions = gql`
  query DebitCardFundingOptions {
    debitCardFundingOptions {
      __typename
      ... on DebitCardFundingOptionsSuccess {
        options {
          ... on DebitCardFundingOptionFixed {
            id
            title
          }
          ... on DebitCardFundingOptionCustom {
            id
            title
            minAmount {
              ...money
            }
            maxAmount {
              ...money
            }
          }
        }
        maxAmount {
          ...money
        }
        defaultAmount {
          ...money
        }
        minAmount {
          ...money
        }
      }
      ... on DebitCardFundingOptionsNotEligible {
        ...error
      }
      ... on DebitCardFundingOptionsError {
        ...error
      }
    }
  }
  ${money}
  ${error}
`;

export default DebitCardFundingOptions;
